import React from 'react';
import { Section, TwoColumns } from '../Section';
import { Paragraph, SectionTitle, StyledLinkA } from '../Typography';
import sizes from 'src/style/sizes';
import Comet from '../Illustrations/Comet.svg';
import { mediaQueries } from '../../style/breakpoints';
import colors from 'src/style/colors';

/* --- roughNotation --- */
// import Sensor from '../Sensor';
// import RoughNotation from '../Notation';
// import { RoughNotationGroup } from 'react-rough-notation';

const goalData = {
  fullAndPartTime: [
    "Le format bootcamp vous donne la possibilité de changer rapidement de voie professionnelle. À l'issue de la formation, la plupart des élèves poursuivent en contrat d'apprentissage (alternance) pour obtenir un Titre RNCP de niveau 6 (Bac+3/4) et acquérir une première expérience professionnelle significative.",
    "Nous vous accompagnons activement dans votre recherche en mettant en avant votre profil auprès de notre réseau d'entreprises partenaires. D'autres options sont également possibles comme le stage (nous vous fournissons une convention de stage de 6 mois), le CDI, ou des missions en freelance.",
  ],
  alternance: [
    "L'alternance, c'est l'assurance d'évoluer au sein d'une entreprise, en CDD, et de se former en même temps. En intégrant Le Reacteur, vous aurez un programme de formation adapté à votre niveau de compétences et à la demande de votre entreprise d'accueil. Vous vous formerez à nos côtés, sur des concepts avancés, pour une montée en compétences fulgurante !",
    "Après l'alternance, ce sera l'occasion de partir en free-lance ou rejoindre une entreprise en CDI.",
  ],
  eLearning: [
    "Notre formation en e-learning, vous permet de démarrer à votre rythme l'apprentissage du code.",
    'Elle a pour objectif de vous fournir une base solide en programmation, ce qui vous aidera à aborder avec confiance les concepts de nos formations plus avancées et à relever des défis plus complexes dans le domaine du développement Web.',
  ],
};

const Career = React.memo(({ id, training, landing, setIsModalFormOpen, images, courseType }) => {
  return (
    <Section id={id} theme="light">
      <TwoColumns
        reverse
        sizeLeft={sizes.columnWidth.large}
        left={
          // <Sensor>
          //   {({ isVisible }) => (
          //     <RoughNotationGroup>
          <div css={{ [mediaQueries.tabletLandscapeUp]: { paddingRight: 80 } }}>
            <SectionTitle>
              Notre objectif :{' '}
              {training === 'eLearning'
                ? 'lancer votre carrière dans le développement'
                : courseType === 'Alternance'
                ? 'faire de vous un développeur confirmé AI-driven'
                : "votre retour rapide à l'emploi"}
            </SectionTitle>
            <Paragraph>{goalData[training][0]}</Paragraph>
            <Paragraph css={{ paddingTop: 0 }}>{goalData[training][1]}</Paragraph>
            {training === 'eLearning' ? (
              <Paragraph css={{ paddingTop: 0 }}>
                Après une expérience professionnelle de deux mois (voir modalités{' '}
                <StyledLinkA
                  color={colors.purple}
                  href={'https://www.lereacteur.io/titre-rncp-developpeur-web-et-web-mobile'}
                  // rel="noopener noreferrer nofollow"
                  target="_blank"
                >
                  en cliquant ici)
                </StyledLinkA>
                , vous pourrez passer, si vous le souhaitez, l’examen du titre RNCP de niveau 5 de
                Développeur Web et Web Mobile (frais en sus).
              </Paragraph>
            ) : null}
          </div>
        }
        sizeRight={sizes.columnWidth.medium}
        right={
          <div
            css={{
              paddingTop: 0,
              marginTop: -40,
              marginLeft: -60,
              marginBottom: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              [mediaQueries.tabletLandscapeUp]: {
                marginTop: 65,
              },
            }}
          >
            <img src={Comet} alt="illustration comète" css={{ width: '100%', maxWidth: 400 }} />
          </div>
        }
      />
    </Section>
  );
});
export default Career;
